<section
  class="simple-table row d-flex justify-content-center"
  [ngClass]="'simple-table--theme-' + theme()"
>
  <div class="simple-table__content col-lg-12">
    <div class="ed-center col-lg-8">
      <h2 *scText="headingField()"></h2>
      <p *scText="introductionField()"></p>
    </div>
    <div class="col-lg-12">
      <wl-rich-text-wrapper [field]="tableField()">
        <div class="table-responsive"></div>
      </wl-rich-text-wrapper>
    </div>
    <div class="ed-center col-lg-8">
      @if (showButton() || isEditorActive()) {
        <div class="cta">
          <crnt-button-alt
            variant="secondary"
            [inverted]="isButtonInverted()"
            wlTrackLink
            [trackLinkInfo]="{
              rendering: { componentName: 'StepsComponent' },
              field: button()?.value?.text || '',
              eventType: 'button-click',
              type: 'button',
            }"
          >
            <a *wlGenericLink="button()"></a>
          </crnt-button-alt>
        </div>
      }
    </div>
  </div>
</section>
